import React from "react";

const VirtualAccountNumberDisclosure = () => (
  <section>
    <p>
      Apex Clearing Corporation (the &ldquo;Firm&rdquo;) is committed to
      protecting your privacy and ensuring the security of your account during
      the deposit of funds into your brokerage account. To facilitate this
      process securely and efficiently, the Firm may issue or use a Virtual
      Account Number (&ldquo;VAN&rdquo;).
    </p>
    <p>
      Please carefully review the following important disclosures regarding the
      use of VANs:
    </p>
    <ol>
      <li>
        <strong>Purpose of the VAN:</strong>
        <p>
          The VAN is used to facilitate the deposit of funds into your brokerage
          account. This may include, but is not limited to, deposits resulting
          from:
        </p>
        <ol type="a">
          <li>A rollover from an Individual Retirement Account (IRA);</li>
          <li>Direct deposit transactions;</li>
          <li>Employer contributions; and</li>
          <li>
            Other forms of fund deposits that may become applicable in the
            future, as determined by your introducing broker.
          </li>
        </ol>
      </li>
      <li>
        <strong>Security Measures:</strong>
        <p>
          The VAN is issued as a secure identifier to protect your personal and
          financial information during the deposit process. The Firm employs
          industry-standard safeguards to ensure the confidentiality and
          integrity of your transactions.
        </p>
      </li>
      <li>
        <strong>Customer Responsibility and Communication:</strong>
        <p>
          You are encouraged to use the VAN only in accordance with the
          guidelines or instructions provided by the Firm or your introducing
          broker. If you have any questions about its use or believe that the
          security of your VAN has been compromised, please notify your
          introducing broker dealer and the Firm immediately.
        </p>
      </li>
      <li>
        <strong>VAN Expiration and Non-Reusability:</strong>
        <p>
          The VAN may expire after the completion of your deposit transaction or
          within specified time frames as determined by the Firm or your
          introducing broker-dealer. Once issued, the VAN is non-transferable
          and may not be reused without explicit authorization by the Firm or
          your introducing broker.
        </p>
      </li>
      <li>
        <strong>No Guarantee of Future Use:</strong>
        <p>
          The issuance and use of a VAN are discretionary and do not guarantee
          that a VAN will be provided for all deposit transactions or other
          account-related purposes in the future. The Firm reserves the right to
          modify or discontinue the use of VANs at its sole discretion.
        </p>
      </li>
      <li>
        <strong>Acknowledgment of Firm Disclaimers:</strong>
        <p>
          While the VAN is implemented as an additional security measure, the
          Firm does not guarantee the security of any system or process against
          all potential risks. By proceeding with a deposit transaction
          involving the use of a VAN, you acknowledge and agree to the terms
          outlined in this disclosure. Any misuse of the VAN or deviation from
          its intended use may cause delays or other unintended consequences for
          which the Firm will not be held liable.
        </p>
      </li>
    </ol>
    <p>
      For further information about the use of a VAN or your deposit
      transaction, please contact your introducing broker dealer.
    </p>
    <p>
      <strong>Disclaimer:</strong> This disclosure is provided for informational
      purposes only and is not intended as legal, tax, or financial advice. For
      guidance specific to your circumstances, you are encouraged to consult
      your own professional advisor(s).
    </p>
  </section>
);

export default VirtualAccountNumberDisclosure;
